import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { tableMessages } from 'src/registry/components/table/utils/messages';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';

export type DataTableSearchInfoProps = {
    fields: string[];
};

export function DataTableSearchInfo({ fields }: DataTableSearchInfoProps) {
    const { formatMessage, locale } = useIntl();

    const fieldsText = new Intl.ListFormat(locale, { style: 'long', type: 'disjunction' }).format(fields);

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button variant="ghost" size="icon" aria-label={formatMessage(tableMessages.searchInfo)}>
                        <FontAwesomeIcon
                            icon={faCircleQuestion}
                            className="stroke-current stroke-[2px] text-[22px] text-gray-600"
                        />
                    </Button>
                </TooltipTrigger>
                <TooltipContent className="flex min-h-18 flex-row items-center justify-start sm:max-w-lg sm:gap-2">
                    <>
                        <FontAwesomeIcon icon={faCircleQuestion} className="text-[16px] text-gray-600" />
                        {formatMessage(tableMessages.searchByFields, { fields: fieldsText })}
                    </>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
